/**
 * Created by daniel on 02/05/17.
 */

import React, {Component} from 'react';
import {getImages} from "../state/images/selectors";
import {connect} from "react-redux";
import {Dialog, FlatButton, GridList, GridTile, TextField} from "material-ui";
import './ImageBrowser.css';

// Renders a dialog that allows a user to pick an image, and fire a callback
// Remember to close the dialog in the callback!

class ImageBrowser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPicture: props.currentImage,
    };
  }
  
  render() {
    
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={() => this.props.callback(null)}
      />,
      <FlatButton
        label="Choose Picture"
        primary={true}
        disabled={!this.state.selectedPicture}
        onTouchTap={() => this.props.callback(this.state.selectedPicture)}
      />,
    ];
    
    return (
      <Dialog
        className="image-browser-dialog"
        open={this.props.open}
        title="Select an image, or input an image URL"
        modal={true}
        actions={actions}
      >
        <GridList
          cols={3}
          style={{
            height: "50vh",
            overflowY: 'auto',
            padding: "5px",
          }}
        >
          {this.props.images.map((item) => {
            
            
            return <GridTile
              className="grid-item"
              key={item.imageId}
              title={item.imageAlt}
              style={{
                cursor: "pointer",
                opacity: this.state.selectedPicture && this.state.selectedPicture.imageUrl && (this.state.selectedPicture.imageUrl !== item.imageUrl) ? 0.5 : 1,
              }}
              onTouchTap={() => {
                if (!this.state.selectedPicture || this.state.selectedPicture.imageUrl !== item.imageUrl) {
                  this.setState({selectedPicture: item})
                } else {
                  this.setState({selectedPicture: null})
                }
              }}
            >
              <img
                src={item.imageUrl}
                alt={item.imageAlt}
              />
            </GridTile>
          })}
        </GridList>
        <TextField
          floatingLabelText="Image URL"
          fullWidth={true}
          value={this.state.selectedPicture && this.state.selectedPicture.imageUrl ? this.state.selectedPicture.imageUrl : "" }
          onChange={(e) => {
              this.setState({selectedPicture: {...this.state.selectedPicture, imageUrl: e.target.value}})
          }}
        />
        <TextField
          floatingLabelText="Image ALT text"
          fullWidth={true}
          value={this.state.selectedPicture && this.state.selectedPicture.imageAlt ? this.state.selectedPicture.imageAlt : "" }
          onChange={(e) => {
              this.setState({selectedPicture: {...this.state.selectedPicture, imageAlt: e.target.value}})
          }}
        />
        <TextField
          floatingLabelText="Image hyperlink"
          fullWidth={true}
          value={this.state.selectedPicture && this.state.selectedPicture.imageLink ? this.state.selectedPicture.imageLink : "" }
          onChange={(e) => {
            this.setState({selectedPicture: {...this.state.selectedPicture, imageLink: e.target.value}})
          }}
        />
      </Dialog>
    );
  }
}

function mapStateToProps(state, ownprops) {
  return {
    currentImage: ownprops.currentImage,
    images: getImages(state),
    open: ownprops.open,
    callback: ownprops.callback
  }
}

export default connect(mapStateToProps)(ImageBrowser);


// WEBPACK FOOTER //
// ./src/App/components/ImageBrowser.js